import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M24.1601 22.87C24.0601 22.86 23.9401 22.86 23.8301 22.87C21.4501 22.79 19.5601 20.84 19.5601 18.44C19.5601 15.99 21.5401 14 24.0001 14C26.4501 14 28.4401 15.99 28.4401 18.44C28.4301 20.84 26.5401 22.79 24.1601 22.87Z",
  stroke: "#292E36",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.1602 26.56C16.7402 28.18 16.7402 30.82 19.1602 32.43C21.9102 34.27 26.4202 34.27 29.1702 32.43C31.5902 30.81 31.5902 28.17 29.1702 26.56C26.4302 24.73 21.9202 24.73 19.1602 26.56Z",
  stroke: "#292E36",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { withDefaults } from 'vue';

  interface IProps {
    color?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

  const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
}

})